import type { VButtonProps } from "@verbleif/lib/src/components/Button/VButton.types";
import type { IconName } from "@verbleif/lib/src/components/Icon/icons";
import type { ExternalToast } from "vue-sonner";
import { markRaw } from "vue";
import { toast as sonner } from "vue-sonner";
import SonnerCustom from "./SonnerCustom.vue";
import { PROGRESS_TOASTER_ID } from "./toasterIds";

export interface HeadlessProgressToastViolations {
  [key: string]: string[]
}

export interface HeadlessProgressToastProps {
  title: string
  message: string
  value?: number
  isComplete?: boolean
  /** The run stopped with an error: shows the error state instead of the running spinner. */
  isFailed?: boolean
  /** For a toast that only announces something (a push notification): this icon in the info tone instead of the progress states. */
  notificationIcon?: IconName
  violations?: HeadlessProgressToastViolations
  hideViolations?: boolean
  hideProgressBar?: boolean
  hideClose?: boolean
  secondaryTitle?: string
  messageRight?: string
  secondaryValue?: number
  secondaryMessage?: string
  secondaryMessageRight?: string
  showSecondaryProgressBar?: boolean
  /** The last button is drawn as the primary one, unless it sets its own variant. */
  buttons?: (VButtonProps & {
    onClick: () => void
    label: string
  })[]
}

export function customToast(toast: ExternalToast & { componentProps: HeadlessProgressToastProps }) {
  // A notification only announces something, so it stacks with the normal toasts instead of staying on top.
  const toasterId = toast.componentProps.notificationIcon ? undefined : PROGRESS_TOASTER_ID;
  return sonner.custom(markRaw(SonnerCustom), {
    toasterId,
    ...toast,
  });
}
